import { BackendRoute } from '../../../../config/index';
import { QueryKey } from '../../../../constants/index';
import { useAppQuery } from '../../../../hooks/use-app-query.hook';
import ApiService from '../../../../services/api-service.util';

const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const base64ToFile = (base64: string, documentName: string) => {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  const blob = new Blob([bytes], { type: DOCX_MIME });
  return new File([blob], documentName, { type: blob.type });
};

export const useTemplateDocument = ({
  templateId,
  fileLink,
  enabled,
}: {
  enabled: boolean;
  fileLink: null | string | undefined;
  templateId: null | string;
}) => {
  const hasFileLink = (fileLink?.trim?.() ?? '') !== '';
  const {
    data: file,
    isPending,
    isError,
  } = useAppQuery<File | null>({
    queryKey: [QueryKey.GET_TEMPLATE_DOCUMENT, templateId, fileLink ?? ''],
    queryFn: async () => {
      const res = await ApiService.get<{ documentBase64: string; documentName: string }>({
        endpoint: BackendRoute.TEMPLATES,
        routePath: [templateId!, 'document'],
      });
      return base64ToFile(res.documentBase64, res.documentName);
    },
    enabled: !!templateId && hasFileLink && enabled,
  });

  return {
    file: file ?? null,
    isPending,
    isError,
  };
};
